import axios from "axios";
import { TParamsUser } from "./UserManagement";

export const getUserReportsApi = (params?: TParamsUser) => {
  return axios.get("/user-reports", { params });
};

export const getPostReportsApi = (params?: TParamsUser) => {
  return axios.get("/user-reports/posts", { params });
};

export const getCommentReportsApi = (params?: TParamsUser) => {
  return axios.get("/user-reports/comments", { params });
};

export const putCommentReportsApi = (id: number, handle: boolean) => {
  return axios.put(`/user-reports/${id}`, { handle });
};

export const forceDeletePostApi = async (id: number) => {
  const { data } = await axios.delete(`/posts/admin/force/${id}`);
  return data;
};

export const deleteReportApi = (id: number) => {
  return axios.delete(`/user-reports/${id}`);
};
